import * as ControllerInterfaces from '../Interfaces/ControllerInterfacesBarrel';
// Import the abstract controller factory.
import AbstractControllerFactory from './AbstractControllerFactory';
// Import the implemented production controllers.
import * as ProductControllers from '../Production/ProductionControllersBarrel';

export default class ProductionControllerFactory extends AbstractControllerFactory {

    public constructor() {
        super();
    }

    public getAppLinkController(): ControllerInterfaces.IAppLinkController {
        return new ProductControllers.ProductionAppLinkController();
    }

    public getAuthenticationController(): ControllerInterfaces.IAuthenticationController {
        return new ProductControllers.ProductionAuthenticationController();
    }

    public getClaimsController(): ControllerInterfaces.IClaimsController {
        return new ProductControllers.ProductionClaimsController();
    }

    public getDocumentController(): ControllerInterfaces.IDocumentController {
        return new ProductControllers.ProductionDocumentController();
    }

    public getEligibilityMessagePriorityController(): ControllerInterfaces.IEligibilityMessagePriorityController {
        return new ProductControllers.ProductionEligibilityMessagePriorityController();
    }

    public getEndorsementController(): ControllerInterfaces.IEndorsementController {
        return new ProductControllers.ProductionEndorsementController();
    }

    public getEndorsementMortgageeController(): ControllerInterfaces.IEndorsementMortgageeController {
        return new ProductControllers.ProductionEndorsementMortgageeController();
    }

    public getEndorsementPolicyEntityController(): ControllerInterfaces.IEndorsementPolicyEntityController {
        return new ProductControllers.ProductionEndorsementPolicyEntityController();
    }

    public getEndorsementValidationController(): ControllerInterfaces.IEndorsementValidationController {
        return new ProductControllers.ProductionEndorsementValidationController();
    }

    public getIdentityController(): ControllerInterfaces.IIdentityController {
        return new ProductControllers.ProductionIdentityController();
    }

    public getMinCostPerSquareFootController(): ControllerInterfaces.IMinCostPerSquareFootController {  
        return new ProductControllers.ProductionMinCostPerSquareFootController();
    }

    public getMinCostPerSquareFootLookupController(): ControllerInterfaces.IMinCostPerSquareFootLookupController {
        return new ProductControllers.ProductionMinCostPerSquareFootLookupController();
    }

    public getMinCostPerSquareFootVersionController(): ControllerInterfaces.IMinCostPerSquareFootVersionController {
        return new ProductControllers.ProductionMinCostPerSquareFootVersionController();
    }

    public getNewBusinessApplicationController(): ControllerInterfaces.INewBusinessApplicationController {
        return new ProductControllers.ProductionNewBusinessApplicationController();
    }

    public getPolicyController(): ControllerInterfaces.IPolicyController {
        return new ProductControllers.ProductionPolicyController();
    }

    public getPolicyNoteController(): ControllerInterfaces.IPolicyNoteController {
        return new ProductControllers.ProductionPolicyNoteController();
    }

    public getProductController(): ControllerInterfaces.IProductController {
        return new ProductControllers.ProductionProductController();
    }

    public getPropertyController(): ControllerInterfaces.IPropertyController {
        return new ProductControllers.ProductionPropertyController();
    }

    public getRolesController(): ControllerInterfaces.IRolesController {
        return new ProductControllers.ProductionRolesController();
    }

    public getSignupController(): ControllerInterfaces.ISignUpController {
        return new ProductControllers.ProductionSignupController();
    }
}
